import { Component, Input, output } from '@angular/core';

@Component({
  selector: 'app-cockpit-push-button',
  styleUrls: ['pushbutton.component.scss'],
  templateUrl: 'pushButton.component.html'
})

export class CockpitPushButton {

 @Input() label: string = 'enter label';
 @Input() value: boolean = false;
 handleNameChange = output<string>();
 handleIdChange = output<string>();
 
}